import React from 'react';

import {StudyPhase} from 'graphql-client/__generated/graphqlGlobalTypes';
import {SingleValueFilter} from 'search/SearchConstants';
import {STUDY_FILTER_ANY, STUDY_PHASES} from 'studies/StudyConstants';
import {OptionData} from 'ui-library/menus/MenuConstants';
import pick from 'util/pick';

import DropdownFilterForm, {prefixedToggleText} from './base/DropdownFilterForm';
import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';

interface StudyPhaseFilterFormProps extends BaseFilterFormProps {
  filter: SingleValueFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: SingleValueFilter) => void;
  onRemove?: () => void;
}

export default function StudyPhaseFilterForm(props: StudyPhaseFilterFormProps): JSX.Element {
  const optionDatas: Array<OptionData> = [
    {name: 'Any', value: STUDY_FILTER_ANY},
    ...STUDY_PHASES.map((phase: StudyPhase) => ({
      name: StudyPhase[phase],
      value: phase,
    })),
  ];

  const skeletonProps = pick(props, ...BASE_FILTER_FORM_PROP_NAMES);
  return (
    <DropdownFilterForm
      {...skeletonProps}
      dropdownToggleText={prefixedToggleText('Phase', optionDatas, props.filter)}
      filterStyle={props.filterStyle}
      isMulti={false}
      onChangeValue={(value: StudyPhase) => {
        props.onChangeFilter({...props.filter, value});
      }}
      onRemove={props.onRemove}
      optionDatas={optionDatas}
      value={props.filter.value}
    />
  );
}
